import React from 'react'
import ProgressBar from './ProgressBar'
import { StatusBadge, UsageText } from './ProgressBar/styles'
import styled from 'styled-components'

// You can add additional styling if needed
const AssessmentStatusBadge = styled(StatusBadge)`
  // Any custom styles specific to assessment status
`

const AssessmentProgressBar = ({ sent = 0, completed = 0 }) => {
  // Always set status to active for green color
  const status = 'active'
  
  // Always return "Active" text regardless of completion percentage
  const getStatusText = () => {
    return "Active"
  }
  
  return (
    <div style={{ width: '100%' }}>
      <ProgressBar
        value={completed}
        total={sent || 1} // Avoid division by zero
        status={status}
      >
        <AssessmentStatusBadge status={status}>
          {getStatusText()}
        </AssessmentStatusBadge>
        <UsageText>
          {completed} / {sent}
        </UsageText>
      </ProgressBar>
    </div>
  )
}

export default AssessmentProgressBar